module.exports = __webpack_public_path__ + "static/device_tablet_apple_light_landscape-a4bd2ecb80feaba66301c6b292cc51a8.png";